// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: enums.proto

/* eslint-disable */

export const protobufPackage = "com.meritic.newton";

/** Type of metadata. */
export enum MetadataTypeEnum {
  UNKNOWN_METADATA_TYPE = 0,
  LOGICAL_COLUMN = 1,
  DATA_MODEL = 2,
  METRIC = 3,
  USER = 4,
  ANALYSIS_TREE = 5,
  REPORT_PAGE = 6,
  REPORT_BOOK = 7,
  JOB = 8,
  JOB_RUN = 9,
  ANALYSIS_PLAN = 10,
  ANALYSIS_STEP = 11,
  KG_COLUMN = 12,
  BENCHMARK = 13,
  SCHEDULED_JOB = 14,
  SCHEDULED_JOB_RUN = 15,
  CUSTOM_AGENT = 16,
  ANALYST = 17,
  UNRECOGNIZED = -1,
}

export function metadataTypeEnumFromJSON(object: any): MetadataTypeEnum {
  switch (object) {
    case 0:
    case "UNKNOWN_METADATA_TYPE":
      return MetadataTypeEnum.UNKNOWN_METADATA_TYPE;
    case 1:
    case "LOGICAL_COLUMN":
      return MetadataTypeEnum.LOGICAL_COLUMN;
    case 2:
    case "DATA_MODEL":
      return MetadataTypeEnum.DATA_MODEL;
    case 3:
    case "METRIC":
      return MetadataTypeEnum.METRIC;
    case 4:
    case "USER":
      return MetadataTypeEnum.USER;
    case 5:
    case "ANALYSIS_TREE":
      return MetadataTypeEnum.ANALYSIS_TREE;
    case 6:
    case "REPORT_PAGE":
      return MetadataTypeEnum.REPORT_PAGE;
    case 7:
    case "REPORT_BOOK":
      return MetadataTypeEnum.REPORT_BOOK;
    case 8:
    case "JOB":
      return MetadataTypeEnum.JOB;
    case 9:
    case "JOB_RUN":
      return MetadataTypeEnum.JOB_RUN;
    case 10:
    case "ANALYSIS_PLAN":
      return MetadataTypeEnum.ANALYSIS_PLAN;
    case 11:
    case "ANALYSIS_STEP":
      return MetadataTypeEnum.ANALYSIS_STEP;
    case 12:
    case "KG_COLUMN":
      return MetadataTypeEnum.KG_COLUMN;
    case 13:
    case "BENCHMARK":
      return MetadataTypeEnum.BENCHMARK;
    case 14:
    case "SCHEDULED_JOB":
      return MetadataTypeEnum.SCHEDULED_JOB;
    case 15:
    case "SCHEDULED_JOB_RUN":
      return MetadataTypeEnum.SCHEDULED_JOB_RUN;
    case 16:
    case "CUSTOM_AGENT":
      return MetadataTypeEnum.CUSTOM_AGENT;
    case 17:
    case "ANALYST":
      return MetadataTypeEnum.ANALYST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MetadataTypeEnum.UNRECOGNIZED;
  }
}

export function metadataTypeEnumToJSON(object: MetadataTypeEnum): string {
  switch (object) {
    case MetadataTypeEnum.UNKNOWN_METADATA_TYPE:
      return "UNKNOWN_METADATA_TYPE";
    case MetadataTypeEnum.LOGICAL_COLUMN:
      return "LOGICAL_COLUMN";
    case MetadataTypeEnum.DATA_MODEL:
      return "DATA_MODEL";
    case MetadataTypeEnum.METRIC:
      return "METRIC";
    case MetadataTypeEnum.USER:
      return "USER";
    case MetadataTypeEnum.ANALYSIS_TREE:
      return "ANALYSIS_TREE";
    case MetadataTypeEnum.REPORT_PAGE:
      return "REPORT_PAGE";
    case MetadataTypeEnum.REPORT_BOOK:
      return "REPORT_BOOK";
    case MetadataTypeEnum.JOB:
      return "JOB";
    case MetadataTypeEnum.JOB_RUN:
      return "JOB_RUN";
    case MetadataTypeEnum.ANALYSIS_PLAN:
      return "ANALYSIS_PLAN";
    case MetadataTypeEnum.ANALYSIS_STEP:
      return "ANALYSIS_STEP";
    case MetadataTypeEnum.KG_COLUMN:
      return "KG_COLUMN";
    case MetadataTypeEnum.BENCHMARK:
      return "BENCHMARK";
    case MetadataTypeEnum.SCHEDULED_JOB:
      return "SCHEDULED_JOB";
    case MetadataTypeEnum.SCHEDULED_JOB_RUN:
      return "SCHEDULED_JOB_RUN";
    case MetadataTypeEnum.CUSTOM_AGENT:
      return "CUSTOM_AGENT";
    case MetadataTypeEnum.ANALYST:
      return "ANALYST";
    case MetadataTypeEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of logical column. */
export enum ColumnType {
  UNKNOWN_COLUMN_TYPE = 0,
  MEASURE = 1,
  ATTRIBUTE = 2,
  TEMPORAL = 3,
  UNRECOGNIZED = -1,
}

export function columnTypeFromJSON(object: any): ColumnType {
  switch (object) {
    case 0:
    case "UNKNOWN_COLUMN_TYPE":
      return ColumnType.UNKNOWN_COLUMN_TYPE;
    case 1:
    case "MEASURE":
      return ColumnType.MEASURE;
    case 2:
    case "ATTRIBUTE":
      return ColumnType.ATTRIBUTE;
    case 3:
    case "TEMPORAL":
      return ColumnType.TEMPORAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ColumnType.UNRECOGNIZED;
  }
}

export function columnTypeToJSON(object: ColumnType): string {
  switch (object) {
    case ColumnType.UNKNOWN_COLUMN_TYPE:
      return "UNKNOWN_COLUMN_TYPE";
    case ColumnType.MEASURE:
      return "MEASURE";
    case ColumnType.ATTRIBUTE:
      return "ATTRIBUTE";
    case ColumnType.TEMPORAL:
      return "TEMPORAL";
    case ColumnType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of data present in logical column. */
export enum DataType {
  UNKNOWN_DATA_TYPE = 0,
  VARCHAR = 1,
  BOOLEAN = 2,
  INT32 = 3,
  INT64 = 4,
  DOUBLE = 5,
  DATE = 6,
  DATETIME = 7,
  UNRECOGNIZED = -1,
}

export function dataTypeFromJSON(object: any): DataType {
  switch (object) {
    case 0:
    case "UNKNOWN_DATA_TYPE":
      return DataType.UNKNOWN_DATA_TYPE;
    case 1:
    case "VARCHAR":
      return DataType.VARCHAR;
    case 2:
    case "BOOLEAN":
      return DataType.BOOLEAN;
    case 3:
    case "INT32":
      return DataType.INT32;
    case 4:
    case "INT64":
      return DataType.INT64;
    case 5:
    case "DOUBLE":
      return DataType.DOUBLE;
    case 6:
    case "DATE":
      return DataType.DATE;
    case 7:
    case "DATETIME":
      return DataType.DATETIME;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataType.UNRECOGNIZED;
  }
}

export function dataTypeToJSON(object: DataType): string {
  switch (object) {
    case DataType.UNKNOWN_DATA_TYPE:
      return "UNKNOWN_DATA_TYPE";
    case DataType.VARCHAR:
      return "VARCHAR";
    case DataType.BOOLEAN:
      return "BOOLEAN";
    case DataType.INT32:
      return "INT32";
    case DataType.INT64:
      return "INT64";
    case DataType.DOUBLE:
      return "DOUBLE";
    case DataType.DATE:
      return "DATE";
    case DataType.DATETIME:
      return "DATETIME";
    case DataType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of data source. */
export enum DataSourceType {
  UNKNOWN_DATA_SOURCE_TYPE = 0,
  SNOWFLAKE = 1,
  THOUGHTSPOT = 2,
  UNRECOGNIZED = -1,
}

export function dataSourceTypeFromJSON(object: any): DataSourceType {
  switch (object) {
    case 0:
    case "UNKNOWN_DATA_SOURCE_TYPE":
      return DataSourceType.UNKNOWN_DATA_SOURCE_TYPE;
    case 1:
    case "SNOWFLAKE":
      return DataSourceType.SNOWFLAKE;
    case 2:
    case "THOUGHTSPOT":
      return DataSourceType.THOUGHTSPOT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataSourceType.UNRECOGNIZED;
  }
}

export function dataSourceTypeToJSON(object: DataSourceType): string {
  switch (object) {
    case DataSourceType.UNKNOWN_DATA_SOURCE_TYPE:
      return "UNKNOWN_DATA_SOURCE_TYPE";
    case DataSourceType.SNOWFLAKE:
      return "SNOWFLAKE";
    case DataSourceType.THOUGHTSPOT:
      return "THOUGHTSPOT";
    case DataSourceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** List of allowed buckets for temporal columns. */
export enum TimeBucket {
  NO_BUCKET = 0,
  DAILY = 1,
  WEEKLY = 2,
  MONTHLY = 3,
  QUARTERLY = 4,
  YEARLY = 5,
  UNRECOGNIZED = -1,
}

export function timeBucketFromJSON(object: any): TimeBucket {
  switch (object) {
    case 0:
    case "NO_BUCKET":
      return TimeBucket.NO_BUCKET;
    case 1:
    case "DAILY":
      return TimeBucket.DAILY;
    case 2:
    case "WEEKLY":
      return TimeBucket.WEEKLY;
    case 3:
    case "MONTHLY":
      return TimeBucket.MONTHLY;
    case 4:
    case "QUARTERLY":
      return TimeBucket.QUARTERLY;
    case 5:
    case "YEARLY":
      return TimeBucket.YEARLY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TimeBucket.UNRECOGNIZED;
  }
}

export function timeBucketToJSON(object: TimeBucket): string {
  switch (object) {
    case TimeBucket.NO_BUCKET:
      return "NO_BUCKET";
    case TimeBucket.DAILY:
      return "DAILY";
    case TimeBucket.WEEKLY:
      return "WEEKLY";
    case TimeBucket.MONTHLY:
      return "MONTHLY";
    case TimeBucket.QUARTERLY:
      return "QUARTERLY";
    case TimeBucket.YEARLY:
      return "YEARLY";
    case TimeBucket.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Types of sorting which can be applied on columns. */
export enum SortByEnum {
  NO_SORT = 0,
  ASCENDING = 1,
  DESCENDING = 2,
  UNRECOGNIZED = -1,
}

export function sortByEnumFromJSON(object: any): SortByEnum {
  switch (object) {
    case 0:
    case "NO_SORT":
      return SortByEnum.NO_SORT;
    case 1:
    case "ASCENDING":
      return SortByEnum.ASCENDING;
    case 2:
    case "DESCENDING":
      return SortByEnum.DESCENDING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SortByEnum.UNRECOGNIZED;
  }
}

export function sortByEnumToJSON(object: SortByEnum): string {
  switch (object) {
    case SortByEnum.NO_SORT:
      return "NO_SORT";
    case SortByEnum.ASCENDING:
      return "ASCENDING";
    case SortByEnum.DESCENDING:
      return "DESCENDING";
    case SortByEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of aggregations which can be applied on columns. */
export enum AggregationType {
  NO_AGGREGATION = 0,
  SUM = 1,
  AVERAGE = 2,
  COUNT = 3,
  UNIQUE_COUNT = 4,
  GROWTH = 5,
  MIN = 6,
  MAX = 7,
  UNRECOGNIZED = -1,
}

export function aggregationTypeFromJSON(object: any): AggregationType {
  switch (object) {
    case 0:
    case "NO_AGGREGATION":
      return AggregationType.NO_AGGREGATION;
    case 1:
    case "SUM":
      return AggregationType.SUM;
    case 2:
    case "AVERAGE":
      return AggregationType.AVERAGE;
    case 3:
    case "COUNT":
      return AggregationType.COUNT;
    case 4:
    case "UNIQUE_COUNT":
      return AggregationType.UNIQUE_COUNT;
    case 5:
    case "GROWTH":
      return AggregationType.GROWTH;
    case 6:
    case "MIN":
      return AggregationType.MIN;
    case 7:
    case "MAX":
      return AggregationType.MAX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AggregationType.UNRECOGNIZED;
  }
}

export function aggregationTypeToJSON(object: AggregationType): string {
  switch (object) {
    case AggregationType.NO_AGGREGATION:
      return "NO_AGGREGATION";
    case AggregationType.SUM:
      return "SUM";
    case AggregationType.AVERAGE:
      return "AVERAGE";
    case AggregationType.COUNT:
      return "COUNT";
    case AggregationType.UNIQUE_COUNT:
      return "UNIQUE_COUNT";
    case AggregationType.GROWTH:
      return "GROWTH";
    case AggregationType.MIN:
      return "MIN";
    case AggregationType.MAX:
      return "MAX";
    case AggregationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** List of operators that can be used to filter column data. */
export enum FilterOperator {
  NO_FILTER_OP = 0,
  EQ = 1,
  NE = 2,
  GT = 3,
  GTE = 4,
  LT = 5,
  LTE = 6,
  CONTAINS = 7,
  NOT_CONTAINS = 8,
  UNRECOGNIZED = -1,
}

export function filterOperatorFromJSON(object: any): FilterOperator {
  switch (object) {
    case 0:
    case "NO_FILTER_OP":
      return FilterOperator.NO_FILTER_OP;
    case 1:
    case "EQ":
      return FilterOperator.EQ;
    case 2:
    case "NE":
      return FilterOperator.NE;
    case 3:
    case "GT":
      return FilterOperator.GT;
    case 4:
    case "GTE":
      return FilterOperator.GTE;
    case 5:
    case "LT":
      return FilterOperator.LT;
    case 6:
    case "LTE":
      return FilterOperator.LTE;
    case 7:
    case "CONTAINS":
      return FilterOperator.CONTAINS;
    case 8:
    case "NOT_CONTAINS":
      return FilterOperator.NOT_CONTAINS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FilterOperator.UNRECOGNIZED;
  }
}

export function filterOperatorToJSON(object: FilterOperator): string {
  switch (object) {
    case FilterOperator.NO_FILTER_OP:
      return "NO_FILTER_OP";
    case FilterOperator.EQ:
      return "EQ";
    case FilterOperator.NE:
      return "NE";
    case FilterOperator.GT:
      return "GT";
    case FilterOperator.GTE:
      return "GTE";
    case FilterOperator.LT:
      return "LT";
    case FilterOperator.LTE:
      return "LTE";
    case FilterOperator.CONTAINS:
      return "CONTAINS";
    case FilterOperator.NOT_CONTAINS:
      return "NOT_CONTAINS";
    case FilterOperator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of analysis columns. */
export enum AnalysisColumnType {
  NOT_ANALYSIS_COLUMN = 0,
  COMPOSITION = 1,
  VARIANCE = 2,
  VARIANCE_PERCENTAGE = 3,
  VARIANCE_CONTRIBUTION = 4,
  MELTED_VARIABLE = 5,
  MELTED_VALUE = 6,
  LAST_N_PERIOD_AVERAGE = 7,
  DIAGNOSTIC_STATUS = 8,
  MELTED_BENCHMARK = 9,
  NORMALISED_TARGET = 10,
  ACCOMPLISH_PERCENTAGE = 11,
  COMPOSITION_PERCENTAGE = 12,
  RANK = 13,
  UNRECOGNIZED = -1,
}

export function analysisColumnTypeFromJSON(object: any): AnalysisColumnType {
  switch (object) {
    case 0:
    case "NOT_ANALYSIS_COLUMN":
      return AnalysisColumnType.NOT_ANALYSIS_COLUMN;
    case 1:
    case "COMPOSITION":
      return AnalysisColumnType.COMPOSITION;
    case 2:
    case "VARIANCE":
      return AnalysisColumnType.VARIANCE;
    case 3:
    case "VARIANCE_PERCENTAGE":
      return AnalysisColumnType.VARIANCE_PERCENTAGE;
    case 4:
    case "VARIANCE_CONTRIBUTION":
      return AnalysisColumnType.VARIANCE_CONTRIBUTION;
    case 5:
    case "MELTED_VARIABLE":
      return AnalysisColumnType.MELTED_VARIABLE;
    case 6:
    case "MELTED_VALUE":
      return AnalysisColumnType.MELTED_VALUE;
    case 7:
    case "LAST_N_PERIOD_AVERAGE":
      return AnalysisColumnType.LAST_N_PERIOD_AVERAGE;
    case 8:
    case "DIAGNOSTIC_STATUS":
      return AnalysisColumnType.DIAGNOSTIC_STATUS;
    case 9:
    case "MELTED_BENCHMARK":
      return AnalysisColumnType.MELTED_BENCHMARK;
    case 10:
    case "NORMALISED_TARGET":
      return AnalysisColumnType.NORMALISED_TARGET;
    case 11:
    case "ACCOMPLISH_PERCENTAGE":
      return AnalysisColumnType.ACCOMPLISH_PERCENTAGE;
    case 12:
    case "COMPOSITION_PERCENTAGE":
      return AnalysisColumnType.COMPOSITION_PERCENTAGE;
    case 13:
    case "RANK":
      return AnalysisColumnType.RANK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AnalysisColumnType.UNRECOGNIZED;
  }
}

export function analysisColumnTypeToJSON(object: AnalysisColumnType): string {
  switch (object) {
    case AnalysisColumnType.NOT_ANALYSIS_COLUMN:
      return "NOT_ANALYSIS_COLUMN";
    case AnalysisColumnType.COMPOSITION:
      return "COMPOSITION";
    case AnalysisColumnType.VARIANCE:
      return "VARIANCE";
    case AnalysisColumnType.VARIANCE_PERCENTAGE:
      return "VARIANCE_PERCENTAGE";
    case AnalysisColumnType.VARIANCE_CONTRIBUTION:
      return "VARIANCE_CONTRIBUTION";
    case AnalysisColumnType.MELTED_VARIABLE:
      return "MELTED_VARIABLE";
    case AnalysisColumnType.MELTED_VALUE:
      return "MELTED_VALUE";
    case AnalysisColumnType.LAST_N_PERIOD_AVERAGE:
      return "LAST_N_PERIOD_AVERAGE";
    case AnalysisColumnType.DIAGNOSTIC_STATUS:
      return "DIAGNOSTIC_STATUS";
    case AnalysisColumnType.MELTED_BENCHMARK:
      return "MELTED_BENCHMARK";
    case AnalysisColumnType.NORMALISED_TARGET:
      return "NORMALISED_TARGET";
    case AnalysisColumnType.ACCOMPLISH_PERCENTAGE:
      return "ACCOMPLISH_PERCENTAGE";
    case AnalysisColumnType.COMPOSITION_PERCENTAGE:
      return "COMPOSITION_PERCENTAGE";
    case AnalysisColumnType.RANK:
      return "RANK";
    case AnalysisColumnType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of edges in a metric's knowledge graph. */
export enum MetricEdgeType {
  UNKNOWN_EDGE_TYPE = 0,
  ATTRIBUTE_EDGE = 1,
  BENCHMARK_EDGE = 2,
  FUNDAMENTAL_EDGE = 3,
  METRIC_BENCHMARK_EDGE = 4,
  METRIC_ATTRIBUTE_EDGE = 5,
  METRIC_MEASURE_EDGE = 6,
  METRIC_TIMEFRAME_EDGE = 7,
  METRIC_METRIC_EDGE = 8,
  UNRECOGNIZED = -1,
}

export function metricEdgeTypeFromJSON(object: any): MetricEdgeType {
  switch (object) {
    case 0:
    case "UNKNOWN_EDGE_TYPE":
      return MetricEdgeType.UNKNOWN_EDGE_TYPE;
    case 1:
    case "ATTRIBUTE_EDGE":
      return MetricEdgeType.ATTRIBUTE_EDGE;
    case 2:
    case "BENCHMARK_EDGE":
      return MetricEdgeType.BENCHMARK_EDGE;
    case 3:
    case "FUNDAMENTAL_EDGE":
      return MetricEdgeType.FUNDAMENTAL_EDGE;
    case 4:
    case "METRIC_BENCHMARK_EDGE":
      return MetricEdgeType.METRIC_BENCHMARK_EDGE;
    case 5:
    case "METRIC_ATTRIBUTE_EDGE":
      return MetricEdgeType.METRIC_ATTRIBUTE_EDGE;
    case 6:
    case "METRIC_MEASURE_EDGE":
      return MetricEdgeType.METRIC_MEASURE_EDGE;
    case 7:
    case "METRIC_TIMEFRAME_EDGE":
      return MetricEdgeType.METRIC_TIMEFRAME_EDGE;
    case 8:
    case "METRIC_METRIC_EDGE":
      return MetricEdgeType.METRIC_METRIC_EDGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MetricEdgeType.UNRECOGNIZED;
  }
}

export function metricEdgeTypeToJSON(object: MetricEdgeType): string {
  switch (object) {
    case MetricEdgeType.UNKNOWN_EDGE_TYPE:
      return "UNKNOWN_EDGE_TYPE";
    case MetricEdgeType.ATTRIBUTE_EDGE:
      return "ATTRIBUTE_EDGE";
    case MetricEdgeType.BENCHMARK_EDGE:
      return "BENCHMARK_EDGE";
    case MetricEdgeType.FUNDAMENTAL_EDGE:
      return "FUNDAMENTAL_EDGE";
    case MetricEdgeType.METRIC_BENCHMARK_EDGE:
      return "METRIC_BENCHMARK_EDGE";
    case MetricEdgeType.METRIC_ATTRIBUTE_EDGE:
      return "METRIC_ATTRIBUTE_EDGE";
    case MetricEdgeType.METRIC_MEASURE_EDGE:
      return "METRIC_MEASURE_EDGE";
    case MetricEdgeType.METRIC_TIMEFRAME_EDGE:
      return "METRIC_TIMEFRAME_EDGE";
    case MetricEdgeType.METRIC_METRIC_EDGE:
      return "METRIC_METRIC_EDGE";
    case MetricEdgeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Status of the metadata entity corresponding to the header. */
export enum HeaderStatus {
  /** NO_STATUS - By default */
  NO_STATUS = 0,
  /** USER_SAVED - For analysis tree, whether it is saved or in draft state. */
  USER_SAVED = 1,
  /** STARRED - For conversation, whether it is starred or not. */
  STARRED = 2,
  UNRECOGNIZED = -1,
}

export function headerStatusFromJSON(object: any): HeaderStatus {
  switch (object) {
    case 0:
    case "NO_STATUS":
      return HeaderStatus.NO_STATUS;
    case 1:
    case "USER_SAVED":
      return HeaderStatus.USER_SAVED;
    case 2:
    case "STARRED":
      return HeaderStatus.STARRED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HeaderStatus.UNRECOGNIZED;
  }
}

export function headerStatusToJSON(object: HeaderStatus): string {
  switch (object) {
    case HeaderStatus.NO_STATUS:
      return "NO_STATUS";
    case HeaderStatus.USER_SAVED:
      return "USER_SAVED";
    case HeaderStatus.STARRED:
      return "STARRED";
    case HeaderStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Type of metric - this is used to generate the data strings for the commentary prompt.
 * - Performance metrics like revenue, cash receipts, contribution margin, etc.
 * - Target metrics are internal metrics you track (usually feeds into the performance metric) like
 *   leads, conversion rate, LTV, etc.
 * - Controlled metrics are under the control of the company strategy like marketing spend.
 */
export enum MetricType {
  UNKNOWN_METRIC_TYPE = 0,
  PERFORMANCE = 1,
  TARGET = 2,
  CONTROLLED = 3,
  ADDITIVE = 4,
  RATIO = 5,
  UNRECOGNIZED = -1,
}

export function metricTypeFromJSON(object: any): MetricType {
  switch (object) {
    case 0:
    case "UNKNOWN_METRIC_TYPE":
      return MetricType.UNKNOWN_METRIC_TYPE;
    case 1:
    case "PERFORMANCE":
      return MetricType.PERFORMANCE;
    case 2:
    case "TARGET":
      return MetricType.TARGET;
    case 3:
    case "CONTROLLED":
      return MetricType.CONTROLLED;
    case 4:
    case "ADDITIVE":
      return MetricType.ADDITIVE;
    case 5:
    case "RATIO":
      return MetricType.RATIO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MetricType.UNRECOGNIZED;
  }
}

export function metricTypeToJSON(object: MetricType): string {
  switch (object) {
    case MetricType.UNKNOWN_METRIC_TYPE:
      return "UNKNOWN_METRIC_TYPE";
    case MetricType.PERFORMANCE:
      return "PERFORMANCE";
    case MetricType.TARGET:
      return "TARGET";
    case MetricType.CONTROLLED:
      return "CONTROLLED";
    case MetricType.ADDITIVE:
      return "ADDITIVE";
    case MetricType.RATIO:
      return "RATIO";
    case MetricType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Polarity of a metric indicates whether increase or decrease in metric is good or bad.
 * For eg - Revenue has +ve polarity while Cost has -ve polarity because usually companies aim to
 *          increase the revenue and decrease the cost.
 */
export enum PolarityEnum {
  NO_POLARITY = 0,
  POSITIVE = 1,
  NEGATIVE = 2,
  UNRECOGNIZED = -1,
}

export function polarityEnumFromJSON(object: any): PolarityEnum {
  switch (object) {
    case 0:
    case "NO_POLARITY":
      return PolarityEnum.NO_POLARITY;
    case 1:
    case "POSITIVE":
      return PolarityEnum.POSITIVE;
    case 2:
    case "NEGATIVE":
      return PolarityEnum.NEGATIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PolarityEnum.UNRECOGNIZED;
  }
}

export function polarityEnumToJSON(object: PolarityEnum): string {
  switch (object) {
    case PolarityEnum.NO_POLARITY:
      return "NO_POLARITY";
    case PolarityEnum.POSITIVE:
      return "POSITIVE";
    case PolarityEnum.NEGATIVE:
      return "NEGATIVE";
    case PolarityEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Outcome category indicates the qualitative result based on the metric value's variance
 * from a benchmark. Based on the outcome profile, variance percentage of the metric value can be
 * categorized into seven buckets representing how the metric performed qualitatively.
 */
export enum OutcomeCategory {
  INVALID_OUTCOME_CATEGORY = 0,
  QUITE_UNDER = 1,
  UNDER = 2,
  SLIGHTLY_UNDER = 3,
  IN_LINE = 4,
  SLIGHTLY_OVER = 5,
  OVER = 6,
  QUITE_OVER = 7,
  UNRECOGNIZED = -1,
}

export function outcomeCategoryFromJSON(object: any): OutcomeCategory {
  switch (object) {
    case 0:
    case "INVALID_OUTCOME_CATEGORY":
      return OutcomeCategory.INVALID_OUTCOME_CATEGORY;
    case 1:
    case "QUITE_UNDER":
      return OutcomeCategory.QUITE_UNDER;
    case 2:
    case "UNDER":
      return OutcomeCategory.UNDER;
    case 3:
    case "SLIGHTLY_UNDER":
      return OutcomeCategory.SLIGHTLY_UNDER;
    case 4:
    case "IN_LINE":
      return OutcomeCategory.IN_LINE;
    case 5:
    case "SLIGHTLY_OVER":
      return OutcomeCategory.SLIGHTLY_OVER;
    case 6:
    case "OVER":
      return OutcomeCategory.OVER;
    case 7:
    case "QUITE_OVER":
      return OutcomeCategory.QUITE_OVER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OutcomeCategory.UNRECOGNIZED;
  }
}

export function outcomeCategoryToJSON(object: OutcomeCategory): string {
  switch (object) {
    case OutcomeCategory.INVALID_OUTCOME_CATEGORY:
      return "INVALID_OUTCOME_CATEGORY";
    case OutcomeCategory.QUITE_UNDER:
      return "QUITE_UNDER";
    case OutcomeCategory.UNDER:
      return "UNDER";
    case OutcomeCategory.SLIGHTLY_UNDER:
      return "SLIGHTLY_UNDER";
    case OutcomeCategory.IN_LINE:
      return "IN_LINE";
    case OutcomeCategory.SLIGHTLY_OVER:
      return "SLIGHTLY_OVER";
    case OutcomeCategory.OVER:
      return "OVER";
    case OutcomeCategory.QUITE_OVER:
      return "QUITE_OVER";
    case OutcomeCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Outcome mixture indicates how the metric performed across all dimension values.
 * For eg - if revenue underperformed across all regions, then mixture is uniform.
 * But if it underperformed in some region while over performing in others,
 * then it is mixed outcome.
 */
export enum OutcomeMixture {
  INVALID_OUTCOME_MIXTURE = 0,
  UNIFORM = 1,
  BARELY_MIXED = 2,
  MIXED = 3,
  UNRECOGNIZED = -1,
}

export function outcomeMixtureFromJSON(object: any): OutcomeMixture {
  switch (object) {
    case 0:
    case "INVALID_OUTCOME_MIXTURE":
      return OutcomeMixture.INVALID_OUTCOME_MIXTURE;
    case 1:
    case "UNIFORM":
      return OutcomeMixture.UNIFORM;
    case 2:
    case "BARELY_MIXED":
      return OutcomeMixture.BARELY_MIXED;
    case 3:
    case "MIXED":
      return OutcomeMixture.MIXED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OutcomeMixture.UNRECOGNIZED;
  }
}

export function outcomeMixtureToJSON(object: OutcomeMixture): string {
  switch (object) {
    case OutcomeMixture.INVALID_OUTCOME_MIXTURE:
      return "INVALID_OUTCOME_MIXTURE";
    case OutcomeMixture.UNIFORM:
      return "UNIFORM";
    case OutcomeMixture.BARELY_MIXED:
      return "BARELY_MIXED";
    case OutcomeMixture.MIXED:
      return "MIXED";
    case OutcomeMixture.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Status of the diagnostic analysis corresponding to each data result. */
export enum DiagnosticStatus {
  NO_DIAGNOSIS = 0,
  IGNORE = 1,
  AT_RISK = 2,
  HEALTHY = 3,
  THRIVING = 4,
  UNRECOGNIZED = -1,
}

export function diagnosticStatusFromJSON(object: any): DiagnosticStatus {
  switch (object) {
    case 0:
    case "NO_DIAGNOSIS":
      return DiagnosticStatus.NO_DIAGNOSIS;
    case 1:
    case "IGNORE":
      return DiagnosticStatus.IGNORE;
    case 2:
    case "AT_RISK":
      return DiagnosticStatus.AT_RISK;
    case 3:
    case "HEALTHY":
      return DiagnosticStatus.HEALTHY;
    case 4:
    case "THRIVING":
      return DiagnosticStatus.THRIVING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DiagnosticStatus.UNRECOGNIZED;
  }
}

export function diagnosticStatusToJSON(object: DiagnosticStatus): string {
  switch (object) {
    case DiagnosticStatus.NO_DIAGNOSIS:
      return "NO_DIAGNOSIS";
    case DiagnosticStatus.IGNORE:
      return "IGNORE";
    case DiagnosticStatus.AT_RISK:
      return "AT_RISK";
    case DiagnosticStatus.HEALTHY:
      return "HEALTHY";
    case DiagnosticStatus.THRIVING:
      return "THRIVING";
    case DiagnosticStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Types of benchmark. */
export enum BenchmarkType {
  NO_BENCHMARK = 0,
  VERSUS_BENCHMARK = 1,
  TARGET_BENCHMARK = 2,
  UNRECOGNIZED = -1,
}

export function benchmarkTypeFromJSON(object: any): BenchmarkType {
  switch (object) {
    case 0:
    case "NO_BENCHMARK":
      return BenchmarkType.NO_BENCHMARK;
    case 1:
    case "VERSUS_BENCHMARK":
      return BenchmarkType.VERSUS_BENCHMARK;
    case 2:
    case "TARGET_BENCHMARK":
      return BenchmarkType.TARGET_BENCHMARK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BenchmarkType.UNRECOGNIZED;
  }
}

export function benchmarkTypeToJSON(object: BenchmarkType): string {
  switch (object) {
    case BenchmarkType.NO_BENCHMARK:
      return "NO_BENCHMARK";
    case BenchmarkType.VERSUS_BENCHMARK:
      return "VERSUS_BENCHMARK";
    case BenchmarkType.TARGET_BENCHMARK:
      return "TARGET_BENCHMARK";
    case BenchmarkType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
